import { extend } from 'quasar'
import type { DigitalTwinsFile } from 'src/models'
import { withBase } from 'src/utils/base-url'

export const REL_TYPE_OUTGOING = 'outgoing'
export const REL_TYPE_INCOMING = 'incoming'
export const REL_TYPE_ALL = 'all'

export const QUERY_ALL_TWINS = 'SELECT * FROM digitaltwins'

export const FOLDER_MODEL_ID = 'dtmi:com:arcadis:digitaltwins:Folder;1'
export const FILE_MODEL_ID = 'dtmi:com:arcadis:digitaltwins:File;1'
export const FILE_REL_NAME = 'hasFile'

export const BLOB_REL_NAME = 'hasBlob'
export const ALLOWED_BLOB_MODEL_IDS = [
  'dtmi:com:arcadis:digitaltwins:Blob;1',
  'dtmi:com:arcadis:Blob;1'
]
export const ALLOWED_IMAGE_MODEL_IDS = [
  'dtmi:com:arcadis:digitaltwins:Image;1',
  'dtmi:com:arcadis:Blob:Image;1'
]
export const AUTODESK_FILE_MODEL_ID = 'dtmi:com:arcadis:digitaltwins:AutodeskFile;1'
export const ONELAKE_FILE_MODEL_ID = 'dtmi:com:arcadis:digitaltwins:OneLakeFile;1'

export const ALLOWED_FILE_REL_NAMES = [FILE_REL_NAME, BLOB_REL_NAME]
export const ALLOWED_FILE_MODEL_IDS = [
  'dtmi:com:arcadis:digitaltwins:Blob;1',
  'dtmi:com:arcadis:Blob;1',
  AUTODESK_FILE_MODEL_ID,
  ONELAKE_FILE_MODEL_ID
]

export const EVENT_REL_NAME = 'hasEvent'
export const EVENT_MODEL_ID = 'dtmi:com:arcadis:core:Event;1'
export const ALLOWED_EVENT_MODEL_IDS = [EVENT_MODEL_ID, 'dtmi:digitaltwins:arcadis:core:Event;1']

export const VIEWER_DATA_GROUP_MODEL_ID = 'dtmi:com:arcadis:digitaltwins:ViewerDataGroup;1'
export const ALLOWED_VIEWER_DATA_GROUP_MODEL_IDS = [VIEWER_DATA_GROUP_MODEL_ID]
export const VIEWER_DATA_MODEL_GROUP_REL_NAME = 'includes'

export const VIEWER_DATA_REL_NAME = 'hasModel'
export const VIEWER_DATA_MODEL_ID = 'dtmi:com:arcadis:digitaltwins:ViewerData;1'
export const ALLOWED_VIEWER_DATA_MODEL_IDS = [VIEWER_DATA_MODEL_ID]

export const AUTODESK_SA_EMAIL = import.meta.env.AUTODESK_SA_EMAIL

export const AUTODESK_MODEL_ID = 'dtmi:com:arcadis:digitaltwins:ForgeModel;1'
export type AUTODESK_MODEL_ID_TYPE = 'dtmi:com:arcadis:digitaltwins:ForgeModel;1'
export const ALLOWED_FORGE_MODEL_IDS = [
  AUTODESK_MODEL_ID,
  'dtmi:com:arcadis:ViewerData:ForgeModel:Hub;1',
  'dtmi:com:arcadis:ViewerData:ForgeModel;1'
]
export type ALLOWED_VIEWER_DATA_FORGE_MODEL_TYPES =
  'dtmi:com:arcadis:ViewerData:ForgeModel;1' | AUTODESK_MODEL_ID_TYPE
export type ALLOWED_VIEWER_DATA_FORGE_HUB_MODEL_TYPES =
  'dtmi:com:arcadis:ViewerData:ForgeModel:Hub;1' | AUTODESK_MODEL_ID_TYPE

export const SPATIAL_DATA_MODEL_ID = 'dtmi:com:arcadis:digitaltwins:SpatialData;1'
export type SPATIAL_DATA_MODEL_ID_TYPE = 'dtmi:com:arcadis:digitaltwins:SpatialData;1'
export const GEOJSON_MODEL_ID = 'dtmi:com:arcadis:digitaltwins:GeoJSON;1'
export type GEOJSON_MODEL_ID_TYPE = 'dtmi:com:arcadis:digitaltwins:GeoJSON;1'
export const HAZARD_SPATIAL_DATA_MODEL_ID = 'dtmi:com:arcadis:climaterisk:HazardSpatialData;1'
export type HAZARD_SPATIAL_DATA_MODEL_ID_TYPE = 'dtmi:com:arcadis:climaterisk:HazardSpatialData;1'
export const ALLOWED_SPATIAL_DATA_MODEL_IDS = [
  SPATIAL_DATA_MODEL_ID,
  GEOJSON_MODEL_ID,
  HAZARD_SPATIAL_DATA_MODEL_ID
]
export type ALLOWED_VIEWER_DATA_SPATIAL_DATA_MODEL_TYPES =
  SPATIAL_DATA_MODEL_ID_TYPE | GEOJSON_MODEL_ID_TYPE | HAZARD_SPATIAL_DATA_MODEL_ID_TYPE
export const TILE_LAYER_MODEL_ID = 'dtmi:com:arcadis:digitaltwins:TileLayer;1'
export type TILE_LAYER_MODEL_ID_TYPE = typeof TILE_LAYER_MODEL_ID
export const VECTOR_LAYER_MODEL_ID = 'dtmi:com:arcadis:digitaltwins:VectorLayer;1'
export type VECTOR_LAYER_MODEL_ID_TYPE = typeof VECTOR_LAYER_MODEL_ID
export const ESRI_FEATURESERVER_MODEL_ID = 'dtmi:com:arcadis:digitaltwins:EsriFeatureServer;1'
export type ESRI_FEATURESERVER_MODEL_ID_TYPE = typeof ESRI_FEATURESERVER_MODEL_ID
export const GEOTIFF_MODEL_ID = 'dtmi:com:arcadis:digitaltwins:GeoTIFF;1'
export const ONELAKE_GEOTIFF_MODEL_ID = 'dtmi:com:arcadis:digitaltwins:OneLakeGeoTIFF;1'
export const HAZARD_GEOTIFF_MODEL_ID = 'dtmi:com:arcadis:climaterisk:HazardGeoTIFF;1'
export const SMARTATLASPROJECT_MODEL_ID = 'dtmi:com:arcadis:digitaltwins:SmartAtlasProject;1'
export const ONELAKE_SPATIAL_DATA_MODEL_ID = 'dtmi:com:arcadis:digitaltwins:OneLakeSpatialData;1'
export const STAC_LAYER_MODEL_ID = 'dtmi:com:arcadis:digitaltwins:StacLayer;1'
export type STAC_LAYER_MODEL_ID_TYPE = typeof STAC_LAYER_MODEL_ID
export const MULTIDIM_GEO_MODEL_ID = 'dtmi:com:arcadis:digitaltwins:MultidimGeoLayer;1'
export type MULTIDIM_GEO_MODEL_ID_TYPE = typeof MULTIDIM_GEO_MODEL_ID
export const HAZARD_MULTIDIM_GEO_MODEL_ID =
  'dtmi:com:arcadis:climaterisk:HazardMultidimensionalLayer;1'
export type HAZARD_MULTIDIM_GEO_MODEL_ID_TYPE = typeof HAZARD_MULTIDIM_GEO_MODEL_ID
export const BLOB_MULTIDIM_GEO_MODEL_ID = 'dtmi:com:arcadis:digitaltwins:BlobMultidimGeoLayer;1'
export type BLOB_MULTIDIM_GEO_MODEL_ID_TYPE = typeof BLOB_MULTIDIM_GEO_MODEL_ID

/** All Azure Blob-based GeoTIFF model IDs. Add new GeoTIFF subtypes here to enable map support. */
export const ALLOWED_GEOTIFF_MODEL_IDS = [GEOTIFF_MODEL_ID, HAZARD_GEOTIFF_MODEL_ID]

export const ALLOWED_MAP_MODEL_IDS = [
  ...ALLOWED_SPATIAL_DATA_MODEL_IDS,
  TILE_LAYER_MODEL_ID,
  VECTOR_LAYER_MODEL_ID,
  ESRI_FEATURESERVER_MODEL_ID,
  ...ALLOWED_GEOTIFF_MODEL_IDS,
  ONELAKE_GEOTIFF_MODEL_ID,
  ONELAKE_SPATIAL_DATA_MODEL_ID,
  SMARTATLASPROJECT_MODEL_ID,
  STAC_LAYER_MODEL_ID,
  MULTIDIM_GEO_MODEL_ID,
  BLOB_MULTIDIM_GEO_MODEL_ID
]

/**
 * Viewer-data model ids whose layer is rendered as a raster tile layer (AzureMapsViewer applies
 * `tileOpacityOverrides` only to `atlas.layer.TileLayer`/`AnimatedTileLayer` instances). Vector-rendered
 * layers (SpatialData/GeoJSON, VectorLayer, EsriFeatureServer, OneLakeSpatialData, SmartAtlasProject)
 * and Forge models do not support a live opacity control.
 */
export const ALLOWED_OPACITY_MODEL_IDS = [
  TILE_LAYER_MODEL_ID,
  ...ALLOWED_GEOTIFF_MODEL_IDS,
  ONELAKE_GEOTIFF_MODEL_ID,
  STAC_LAYER_MODEL_ID,
  MULTIDIM_GEO_MODEL_ID
]

/** Whether a viewer-data twin's layer type supports a live opacity control. */
export const supportsOpacity = (modelId?: string): boolean =>
  !!modelId && ALLOWED_OPACITY_MODEL_IDS.includes(modelId)

export const BASE_ENVIRONMENT_MODEL_ID = 'dtmi:com:arcadis:app:Environment;1'
export const USER_MODEL_ID = 'dtmi:com:arcadis:identity:User;1'
export const INVITE_MODEL_ID = 'dtmi:com:arcadis:identity:Invite;1'
export const FEATURE_MODEL_ID = 'dtmi:com:arcadis:app:Feature;2'
export const MAIN_FEATURE_MODEL_ID = 'dtmi:com:arcadis:app:MainFeature;2'
export const DRAWER_FEATURE_MODEL_ID = 'dtmi:com:arcadis:app:DrawerFeature;2'
export const DASHBOARD_FEATURE_MODEL_ID = 'dtmi:com:arcadis:app:DashboardFeature;1'
export const GRID_DASHBOARD_FEATURE_MODEL_ID = 'dtmi:com:arcadis:app:GridDashboardFeature;1'
export const TABLE_FEATURE_MODEL_ID = 'dtmi:com:arcadis:app:TableFeature;2'
export const TREE_TABLE_FEATURE_MODEL_ID = 'dtmi:com:arcadis:app:TreeTableFeature;1'
/**
 * Every feature type that hosts dashboard tiles. The Grid dashboard does not
 * inherit from the GridStack one, so anything asking "is this a dashboard?"
 * has to ask about both.
 */
export const DASHBOARD_FEATURE_MODEL_IDS = [
  DASHBOARD_FEATURE_MODEL_ID,
  GRID_DASHBOARD_FEATURE_MODEL_ID
]
export const QUERY_MODEL_ID = 'dtmi:com:arcadis:app:Query;2'
export const SHARED_QUERY_MODEL_ID = 'dtmi:com:arcadis:app:SharedQuery;1'
export const TABLE_QUERY_MODEL_ID = 'dtmi:com:arcadis:app:TableQuery;2'
export const TREE_TABLE_QUERY_MODEL_ID = 'dtmi:com:arcadis:app:TreeTableQuery;1'
export const DASHBOARD_TILE_MODEL_ID = 'dtmi:com:arcadis:app:DashboardTile;1'
export const FEATURE_QUERY_MODEL_ID = 'dtmi:com:arcadis:app:FeatureQuery;1'

export const QUERY_REL_NAME = 'hasQuery'
export type QUERY_KIND =
  | 'static'
  | 'adx'
  | 'adt'
  | 'shared'
  | 'twinIds'
  | 'selectedIds'
  | 'customParameter'
  | 'arbitraryInput'
  | 'jexl'

export enum QueryKind {
  Static = 'static',
  /** Use a KQL query. Request the query field to be set. */
  ADX = 'adx',
  /** Use an Azure Digital Twins query. Request the query field to be set. */
  ADT = 'adt',
  /** Use a Shared query of the feature. Requires the sharedQuery field to be set. */
  Shared = 'shared',
  /** Generate a query for the provided twinIds. Only used in TimeSeriesTile. Requires the twinIds field to be set. */
  TwinIds = 'twinIds',
  /** Set the twins result of the query to the twins in the store for the selected IDs */
  SelectedIds = 'selectedIds',
  CustomParameter = 'customParameter',
  ArbitraryInput = 'arbitraryInput',
  Jexl = 'jexl'
}

export type PARAM_CONFIG_KIND =
  'duration' | 'datetime' | 'timespan' | 'string' | 'int' | 'double' | 'object' | 'array'

export const PARAM_CONFIG_USE_VARIABLENAME = [
  'datetime',
  'timespan',
  'string',
  'int',
  'double',
  'object',
  'array'
]

export enum ParamConfigKind {
  Duration = 'duration',
  Datetime = 'datetime',
  Timespan = 'timespan',
  String = 'string',
  Int = 'int',
  Double = 'double',
  Object = 'object',
  Array = 'array'
}

export const FLOW_MODEL_ID = 'dtmi:com:arcadis:app:Flow;1'
export const ACTIVITY_MODEL_ID = 'dtmi:com:arcadis:app:Activity;1'

export const ROLE_DEPLOYMENT_ADMINISTRATOR = 'DeploymentAdministrator'
export const ROLES_EDIT = ['admin', 'owner', 'contributor', 'ApplicationAdministrator']
export const ROLES_EDIT_ENVIRONMENT = ['admin', 'owner', 'ApplicationAdministrator']

// Predefined roles for environment access. Custom roles are also supported as any string value.
export const ADD_ROLES_ENVIRONMENT: string[] = ['reader', 'contributor', 'owner']
export type ALLOWED_ADX_ROLES = 'viewer' | 'user' | 'admin'
export const ADX_ROLES: ALLOWED_ADX_ROLES[] = ['viewer', 'user', 'admin']

export type ALLOWED_APIKEY_ROLE = 'flows' | 'reader' | 'contributor' | 'owner'
export const APIKEY_ROLES: ALLOWED_APIKEY_ROLE[] = ['flows', 'reader', 'contributor', 'owner']

export const ROOT_MODEL_ID = 'dtmi:com:arcadis:digitaltwins:Root;1'

/**
 * `$dtId` of the environment's root twin — the single twin every environment's graph hangs from (the
 * tree and breadcrumb features default to it).
 *
 * Use this as the source of a relationship, never the environment id: the environment id is the
 * environment's key in the admin graph, not a twin in the environment's own ADT instance, so a
 * relationship from it is rejected and the new twin is rolled back.
 */
export const ROOT_TWIN_ID = 'root'

export const DEFAULT_ENV_ICON = withBase('/icons/icon-256x256.png')

export const DIGITAL_TWINS_FILE_VERSION = '1.0.0'
export type DIGITAL_TWINS_FILE_VERSION_TYPE = '1.0.0'

export const DIGITAL_TWINS_FILE = extend(
  true,
  {},
  {
    digitalTwinsFileInfo: {
      fileVersion: DIGITAL_TWINS_FILE_VERSION
    },
    digitalTwinsGraph: {
      digitalTwins: [],
      relationships: []
    },
    digitalTwinsModels: []
  }
) as DigitalTwinsFile

export const FAVORITE_ENVIRONMENT = 'starredEnvironments'

/** Public Arcadis legal pages, referenced from the SMS consent disclosure */
export const PRIVACY_POLICY_URL = 'https://digitaltwins.arcadis.com/digitaltwins/privacy/'
export const TERMS_OF_USE_URL = 'https://www.arcadis.com/terms-of-use/'

/** SMS-specific (A2P 10DLC) legal pages on the Digital Twins marketing site.
 *  The marketing site is currently served under /digitaltwins/ (not the domain
 *  root); these URLs reflect the actual published paths. */
export const SMS_PRIVACY_POLICY_URL = 'https://digitaltwins.arcadis.com/digitaltwins/privacy/'
export const SMS_TERMS_OF_USE_URL = 'https://digitaltwins.arcadis.com/digitaltwins/sms-terms/'

/** Phone numbers are stored in international E.164 format, e.g. +32470000000 */
export const E164_PHONE_NUMBER_REGEX = /^\+[1-9]\d{7,14}$/

// used in evaluateCommentValue as context
// eslint-disable-next-line no-secrets/no-secrets
// ex. twinSelectModelIds:=ALLOWED_MAP_MODEL_IDS
export default {
  ALLOWED_FORGE_MODEL_IDS,
  ALLOWED_MAP_MODEL_IDS,
  ALLOWED_VIEWER_DATA_GROUP_MODEL_IDS
}
